import React from "react";
import "./SignIn.css";
import googleLogo from "./logos/google.png";
import appleLogo from "./logos/apple.png";

function SignIn() {
  return (
    <div className="signin-container">
      <div className="login_form">
        <form action="#">
          <h3>Log in with</h3>
          <div className="login_option">
            <div className="option">
              <a href="/#">
                <img src={googleLogo} alt="Google" />
                <span>Google</span>
              </a>
            </div>
            <div className="option">
              <a href="/#">
                <img src={appleLogo} alt="Apple" />
                <span>Apple</span>
              </a>
            </div>
          </div>

          <div>
            <p className="separator">
              <span>or</span>
            </p>
          </div>

          <div className="input_box">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Enter email address"
              required
            />
          </div>

          <div className="input_box">
            <div className="password_title">
              <label htmlFor="password">Password</label>
              <a href="/#">Forgot Password?</a>
            </div>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit">Log In</button>

          <p className="sign_up">
            Don't have an account? <a href="/#">Sign up</a>
          </p>
        </form>
      </div>

      {/* Overlay */}
      <div className="overlay">
        <p>Feature not yet available 🔒</p>
      </div>
    </div>
  );
}

export default SignIn;
